
  import {Component, Prop, Ref, Vue, Watch} from "vue-property-decorator";
  import {ElForm} from "element-ui/types/form";
  import api from "@/api";
  import {
    AttachmentHostType,
    AuditFlowDto, OrganizationUnitDto,
    PaymentCategoryScope, ProjectDto,
    ReimbursementCreateOrEditDto,
    ReimbursementDetailCreateOrUpdateDto
  } from "@/api/appService";
  import OrganizationUnitSelect from "@/components/OrganizationUnitSelect/index.vue";
  import BatchUpload from "@/components/BatchUpload/index.vue";
  import PaymentCategorySelect from "@/components/PaymentCategorySelect/index.vue";

  @Component({
    components: {
      PaymentCategorySelect,
      BatchUpload,
      OrganizationUnitSelect
    }
  })
  export default class EditReimbursement extends Vue {
    @Ref() readonly dataForm!: ElForm;

    @Prop({required: true,default:'org'})
    type!: string;  // org | project

    defaultData: ReimbursementCreateOrEditDto = {
      summary: undefined,
      auditFlowId: undefined,
      id: 0,
      organizationUnitId: undefined,
      savedAttachments: [],
      details: [],
      projectId: undefined,
      requestDate:new Date(),
      ticketCount:0
    };

    show = false;

    form: ReimbursementCreateOrEditDto = {...this.defaultData};

    auditFlows: AuditFlowDto[] = [];

    projects:ProjectDto[] = [];

    created(){
      api.project.getAll({maxResultCount:65535,isAudited:true}).then(res=>{
        this.projects = res.items!.filter(s=>s.isAudited);
      })
      this.defaultData.requestDate = new Date();
    }

    get dialogTitle() {
      return this.form!.id ? "编辑" : "新建";
    }


    get hostType() {
      return AttachmentHostType.Reimbursement;
    }

    get hostId(){
      return this.form.id??0;
    }

    get scopeFilter() {
      if (this.type === 'org') {
        return PaymentCategoryScope.Reimbursement;
      } else {
        return PaymentCategoryScope.Project;
      }

    }


    @Watch("show")
    async onShowChange(value: boolean) {
      console.log('<edit-reimbursement> current type:'+this.type);
      if (value) {
        await api.reimbursement.getForEdit({id: this.form!.id}).then(res => {

          this.form = res.data!;
          if(!this.form.id){
            this.form.requestDate = new Date();
          }
          this.auditFlows = (res.schema as any).auditFlows;
          const currentOu = this.$store.getters['user/ou'] as OrganizationUnitDto;
          if (currentOu.level === '门店' && this.form.id === 0) {
            this.form.organizationUnitId = currentOu.id;
          }

        });
      } else {
        this.form = {...this.defaultData};
        (this.$refs.batchUpload as any).reset();
      }
      this.$nextTick(() => {
        this.dataForm.clearValidate();
      });
    }


    addDetail() {
      const newItem = {amount: undefined, categoryId: undefined, remark: ''} as ReimbursementDetailCreateOrUpdateDto;
      if (this.form.details) {
        this.form.details!.push(newItem)
      } else {
        this.form.details = [newItem];
      }

    }

    handleRemoveDetail(index: number) {
      const result = [] as ReimbursementDetailCreateOrUpdateDto[];
      for (let i = 0; i < this.form.details!.length; i++) {
        if (i === index)
          continue;

        result.push(this.form.details![i]);
      }
      this.form.details = result;


    }

    async save() {
      console.log('<edit-reimbursement>',this.form);
      this.dataForm.validate(async (valid: boolean) => {
        if (valid) {
          if (this.form!.id) {
            await api.reimbursement.update({body: this.form});
          } else {
            await api.reimbursement.create({body: this.form});
          }
          this.show = false;
          this.$message.success("更新成功");
          this.$emit("onSave");
        }
      });
    }

    cancel() {
      this.show = false;
    }

    roleRule = {
      auditFlowId: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ],
      categoryId: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ],
      amount: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ],
      applicant: [
        {
          required: true,
          message: '申请人是必须的',
          trigger: ['change', 'blur']
        }
      ],
      summary: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ],
      projectBudgetNo:[
        {
          type:'string',
          validator:(rule:any,val:string,callback:Function)=>{
            console.log(`<edit-reimbursement> validator:projectBudgetNo, value:${val}, type:${this.type}`)
            if(this.type === 'org'){
              callback();
            } else {
              if(val){
                callback()
              } else {
                callback('项目预算编号是必须的')
              }
            }
          },
          trigger:['blur','change']
        }
      ],
      ticketCount:[
        {
          type:'number',
          validator:(rule:any,val:any,callback:Function)=>{
            if(!val){
              callback(new Error('请输入票据张数'))
            } else if(/^(\d{1,8})$/.test(val.toString()) === false){
              callback(new Error('票据张数必须是一个整数'))
            } else if(parseInt(val) < 1){
              callback(new Error('至少得有一张票据'));
            } else {
              callback();
            }
          },
          trigger:['blur','change']
        }
      ],

      savedAttachments: [
        {
          required: false
        }
      ]
    };
  }
